import PageHeader from '../../components/PageHeader/PageHeader';
import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarSolicitudInterna from './AgregarSolicitudInterna';
import ModificarSolicitudInterna from './ModificarSolicitudInterna';
import GestionCPO from '../solicitudesbooking/GestionCPO';
import { Spinner } from 'react-bootstrap';
import { notificar } from '../../components/SistemaToast/notificar';
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";
import {urlApiProd,print} from '../utiles';



const SolicitudesBookingInternas = () => {
    const [loading, setLoading] = useState(true);
    const [dataSolicitudesInternas, setDataSolicitudesInternas] = useState([]);
    const [dataPuertos, setDataPuertos] = useState([]);
    const [dataClientes, setDataClientes] = useState([]);
    const [dataFFW, setDataFFW] = useState([]);
    const [dataCarrier, setDataCarrier] = useState([]);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowModificar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filterPOD, setFilterPOD] = useState('');
    const [filterMonth, setFilterMonth] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterEstado, setFilterEstado] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [apoyo, setApoyo] = useState(undefined);
    const [principal, setPrincipal] = useState(undefined);
    const firstRender = useRef(true);
    const [showCPO, setShowCPO] = useState(false);
    const [selectedCPO, setSelectedCPO] = useState(null);


const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const SubTablaSolicitudes = ({ solicitudInternaId }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchSolicitudesAsociadas = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${urlApiProd}/solicitudesasociadas/${solicitudInternaId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error fetching solicitudes asociadas');
                const { data } = await response.json();
                //incluir solicitudes si NO están pendientes ni solicitadas
                const datanueva = data.filter((solicitud) => solicitud.estado>=2);       
                setData(datanueva);
            } catch (error) {
                console.error('Error fetching solicitudes asociadas:', error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSolicitudesAsociadas();
    }, [solicitudInternaId]);

    const caseInsensitiveSort = (rowA, rowB) => {
        const a = rowA.title.toLowerCase();
        const b = rowB.title.toLowerCase();
    
        if (a > b) {
            return 1;
        }
    
        if (b > a) {
            return -1;
        }
    
        return 0;
    };

    const columns = [
        { name: 'Booking', selector: row => row.nro_booking,  sortable: true},
        { name: 'FFW', selector: row => row.id_ffw ? dataFFW.find(ffw => ffw.id_ffw === row.id_ffw)?.nombre : '', sortable: true},
        { name: 'Carrier', selector: row => dataCarrier.find(carrier => carrier.id_carrier === row.id_carrier)?.nombre || '', sortable: true},
        { name: 'FT Origen', selector: row => row.ftorigen },
        { name: 'FT Destino', selector: row => row.ftdestino, sortable: true},
        { name: 'Nave', selector: row => row.nave, sortable: true },
        { name: 'DLD', selector: row => row.dld, sortable: true},
        { name: 'DLC', selector: row => row.dlc, sortable: true},
        { name: 'ETD', selector: row => row.etd, sortable: true},
        { name: 'HC', selector: row => row.cantidad, sortable: true },
       // { name: 'id', selector: row => row.id_solicitud, sortable: true },
    ];


    if (loading) {
        return <div>Cargando solicitudes asociadas...</div>;
    }

    if (data.length === 0) {
        //return <div>No hay solicitudes asociadas.</div>;
        return <br></br>;
    }


    const handleCPO = (solicitud) => {
        print(`solicitud ${JSON.stringify(solicitud)}`);
     setSelectedCPO(solicitud);
      setShowCPO(true);
      //fetchData();
    };

    const handleRowClicked = row => {
      console.log(`Row clicked:`, row);
      handleCPO(row);
    };


    return (
        <DataTable
            columns={columns}
            data={data}
            onRowClicked={handleRowClicked}
            pagination
            highlightOnHover
            responsive
        />
    );
};



    const fetchData = async (page = currentPage, rowsPerPage = perPage) => {
        const token = localStorage.getItem('token');
        try {
            // Fetch Solicitudes Internas
            const responseSolicitudesInternas = await fetch(`${urlApiProd}/solicitudesinternas`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!responseSolicitudesInternas.ok) throw new Error('Error fetching solicitudes internas');
            const  data= await responseSolicitudesInternas.json();
            setDataSolicitudesInternas(data);
            //setTotalItems(total);
            setPrincipal(true);
        } catch (error) {
            console.error('Error en fetchData:', error.message);
            setPrincipal(false); // Indica que la solicitud principal falló
            notificar.error(`Solicitudes internas no cargadas: ${error.message}`, { toastId: 'error-principal' });
        }
    };

        const fetchApoyo = async () => {
            const token = localStorage.getItem('token');
            try {
    
                const responses = await Promise.all([
                fetch(`${urlApiProd}/puertos`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/ffw`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/carriers`, { headers: { 'Authorization': `Bearer ${token}` } }),
                fetch(`${urlApiProd}/clientes`, { headers: { 'Authorization': `Bearer ${token}` } }),
            ]);
    
                const [puertos, ffw, carriers, clientes] = await Promise.all(responses.map(res => {
                    if (!res.ok) throw new Error('Error fetching data');
                    return res.json();
                }));
    
                puertos.sort((x, y) => {
                    if (x.nombre < y.nombre) return -1;
                    if (x.nombre > y.nombre) return 1;
                    return 0;
                });
    
                setDataPuertos(puertos);
                setDataClientes(clientes);
                setDataFFW(ffw);
                setDataCarrier(carriers);
                setApoyo(true);
            } catch (error) {
                console.error('Error en fetchApoyo:', error.message);
                setApoyo(false);
                notificar.error(`Datos de apoyo no cargados: ${error.message}`, { toastId: 'error-apoyo' });
            }
        };


    useEffect(() => {
        if (firstRender.current) {
            setLoading(true);
            fetchData();
            fetchApoyo();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (principal !== undefined && apoyo !== undefined) {
            setLoading(!principal || !apoyo);
            if (principal && apoyo) {
                notificar.exito('Datos cargados correctamente.', { toastId: 'success' });
            }
        }
    }, [principal, apoyo]);

    useEffect(() => {
        console.log('Filtrando con:', { filterText, filterMonth, filterYear, filterEstado, filterPOD });
        const filtered = Array.isArray(dataSolicitudesInternas)
            ? dataSolicitudesInternas.filter(solicitud => {
                const matchesText = solicitud.codigo?.toLowerCase().includes(filterText.toLowerCase());
                const matchesMonth = filterMonth
                    ? new Date(solicitud.fecha_creacion).getUTCMonth() + 1 === parseInt(filterMonth)
                    : true;
                const matchesYear = filterYear
                    ? new Date(solicitud.fecha_creacion).getUTCFullYear() === parseInt(filterYear)
                    : true;
                const matchesEstado = filterEstado !== '' ? solicitud.estado === parseInt(filterEstado) : true;
                const matchesPOD = filterPOD ? solicitud.id_puerto_destino === parseInt(filterPOD) : true;

                return matchesText && matchesMonth && matchesYear && matchesEstado && matchesPOD;
            })
            : [];
        setFilteredData(filtered);
    }, [dataSolicitudesInternas, filterText, filterEstado, filterMonth, filterYear, filterPOD]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
    };

    const columns = [
        {
            name: 'Código',
            selector: row => row.codigo,
            width: '200px',
            sortable: true,
        },
        {
            name: 'Cliente',
            selector: row => dataClientes.find(cliente => cliente.id_cliente === row.id_cliente)?.nombre || '',
            sortable: true,
        },
        { 
            name: 'Fecha Creacion',
            selector: row => formatDate(row.fecha_creacion),
            sortable: true,
        },
        {
            name: 'ETD',
            selector: row => formatDate(row.etd),
            sortable: true,
        },
        {
            name: 'Puerto Destino',
            selector: row => dataPuertos.find(p => p.id_puerto === row.id_puerto_destino)?.nombre || '',
            sortable: true,
        },
        {
            name: 'Cantidad',
            selector: row => `${row.cantidad_confirmada ?? 0}/${row.cantidad}`,
        },
        {
            name: 'Free Time Destino',
            selector: row => row.freetimedestino,
        },
        {
            name:'Tipo BL',
            selector: row => row.tipo_bl,
        },  
        {
            name:'Estado',
            selector: row => row.estado === 0 ? 'Pendiente' : row.estado === 1 ? 'Solicitado' : 'Cancelado',
            sortable: true,
        },
    ];

    const handleAgregar = () => setShowAgregar(true);


    
    const handleCloseAgregar = () => {
        setShowAgregar(false);
        fetchData();
    };

    const handleEditar = (solicitud) => {
        setSelected(solicitud);
        setShowModificar(true);
        fetchData();
    };

    const handleCloseModificar = () => {setShowModificar(false); fetchData();};

    const clickSolicitud = row => {
        handleEditar(row);
      }
      const handleCloseCPO = () => {
        setShowCPO(false);
        fetchData();
    };

    const exportToExcel = (solicitudes) => {
        
        // Preparar los datos para el Excel
        const preparedData = solicitudes.map((solicitud) => ({
            Codigo: solicitud.codigo ?? '',
            Cliente: dataClientes.find(cliente => cliente.id_cliente === solicitud.id_cliente)?.nombre || '',
            ETD: solicitud.etd ?? '',
            PuertoDestino: solicitud.id_puerto_destino
            ? dataPuertos.find(p => p.id_puerto === solicitud.id_puerto_destino)?.nombre || ''
            : '',
            CantidadContainers: solicitud.cantidad ?? '',
            FreeTimeDestino: solicitud.freetimedestino ?? '',
            FechaCreacion: formatDate(solicitud.fecha_creacion) ?? '',
            Estado: solicitud.estado === 0 ? 'Pendiente' : solicitud.estado === 1 ? 'Solicitado' : 'Cancelado',
            TipoBL: solicitud.tipo_bl ?? '',
            'Requerimientos Especiales': solicitud.requerimientos ?? '',
        }));
    
        // Crear la hoja de cálculo y el libro de trabajo
        const worksheet = XLSX.utils.json_to_sheet(preparedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Solicitudes");
    
        // Exportar el archivo Excel
        XLSX.writeFile(workbook, "SolicitudesInternasBooking.xlsx");
    };


    const handleEliminar = async (id) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/deletesolicitudinterna/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Error eliminando solicitud interna');
            alert('Solicitud eliminada exitosamente');
            fetchData();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo eliminar la solicitud interna');
        }
    };

    const conditionalRowStyles = [
        {
            when: row => row.estado === 3,
            style: {
              backgroundColor: 'lightgreen',
              '&:hover': {
                  backgroundColor: 'lightgreen',
                  color: 'black',
                cursor: 'pointer',
              },
            },
          },
        {
            when: row => row.estado === 2,
            style: {
              backgroundColor: '#BCE4FC',
              '&:hover': {
                  backgroundColor: '#BCE4FC',
                  color: 'black',
                cursor: 'pointer',
              },
            },
          },
        {
          when: row => row.estado === 1,
          style: {
            backgroundColor: 'lemonchiffon',
            '&:hover': {
                backgroundColor: 'lemonchiffon',
                color: 'black',
              cursor: 'pointer',
            },
          },
        },{
            when: row => row.estado === 0,
          style: {
            backgroundColor: '#FFE1E6',
            '&:hover': {
                backgroundColor: '#FFE1E6',
                color: 'black',
              cursor: 'pointer',
            },
          },
        },{
            when: row => row.estado === -1,
          style: {
            backgroundColor: 'gainsboro',
            '&:hover': {
                backgroundColor: 'gainsboro',
                color: 'black',
              cursor: 'pointer',
            },
          },
        }
      ];

      const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            // use the selector to resolve your field names by passing the sort comparators
            const aField = (selector(a) ?? '').toLowerCase();
            const bField = (selector(b) ?? '').toLowerCase();
    
            let comparison = 0;
    
            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }
    
            return direction === 'asc' ? comparison * -1 : comparison;
        });
    };

    return (
        <div className='container-fluid ui-page'>
            <PageHeader
                eyebrow="Logística · Comercial"
                title="Solicitudes Internas"
                descripcion="Solicitudes internas de booking, con su estado y asignación de contenedores."
                actions={
                    <>
                        <button type="button" className="ui-btn ui-btn-primary" onClick={handleAgregar}>Agregar Solicitud</button>
                        <button type="button" className="ui-btn ui-btn-secondary" onClick={() => exportToExcel(filteredData)}><FaFileExcel /> Exportar</button>
                    </>
                }
            />
            <div className='card'>
                <div className='card-body'>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" role="status" />
                            <span className="sr-only">Cargando...</span>
                        </div>
                    ) : (
                        <>
                                <h4>Filtrar Solicitudes</h4> 
                                <hr></hr>
                            <div className="row mb-3">
                            <div className="col-md-6">
                            <select className="form-select" value={filterPOD} onChange={(e) => setFilterPOD(e.target.value)}>
                            <option value="">Puertos Destino</option>
                                        {dataPuertos.map((pod) => (
                                            <option key={pod.id_puerto} value={pod.id_puerto}>
                                                {pod.nombre}
                                            </option>
                                        ))}
                                    </select>
                            </div>
                            <div className="col-md-6">
                            <input
                                    type="text"
                                    placeholder="Buscar por Código..."
                                    value={filterText}
                                    onChange={(e) => setFilterText(e.target.value)}
                                    className="form-control"
                                />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <select className="form-select" value={filterMonth} onChange={(e) => setFilterMonth(e.target.value)}>
                                        <option value="">Mes</option>
                                        {[...Array(12).keys()].map(month => (
                                            <option key={month + 1} value={month + 1}>
                                                {new Date(0, month).toLocaleString('default', { month: 'long' })}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select className="form-select" value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
                                        <option value="">Año</option>
                                        {Array.from({ length: 5 }, (_, i) => new Date().getUTCFullYear() - i).map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                </div>

                            </div>

                            <div className="col-md-12 mt-3 text-center">
                                    <div className="btn-group" role="group" aria-label="Estado de Solicitudes">
                                        {[
                                            { value: '', label: 'Todos', color: 'secondary' },
                                            { value: '0', label: 'Pendiente', color: 'danger' },
                                            { value: '1', label: 'Solicitado', color: 'warning' },
                                            { value: '-1', label: 'Cancelado', color: 'secondary' },
                                        ].map(({ value, label, color }) => {
                                            const filteredCount = dataSolicitudesInternas.filter((row) => {
                                                const matchesText = row.codigo?.toLowerCase().includes(filterText.toLowerCase());
                                                const matchesMonth = filterMonth
                                                    ? new Date(row.fecha_creacion).getUTCMonth() + 1 === parseInt(filterMonth)
                                                    : true;
                                                const matchesYear = filterYear
                                                    ? new Date(row.fecha_creacion).getUTCFullYear() === parseInt(filterYear)
                                                    : true;
                                                const matchesEstado = value === '' ? true : row.estado === parseInt(value);
                                                const matchesPOD = filterPOD ? row.id_puerto_destino === parseInt(filterPOD) : true;

                                                return matchesText && matchesMonth && matchesYear && matchesEstado && matchesPOD;
                                            }).length;

                                            return (
                                                <button
                                                    key={value}
                                                    type="button"
                                                    className={`btn btn-outline-${color} ${filterEstado === value ? 'active' : ''}`}
                                                    onClick={() => setFilterEstado(value)}
                                                >
                                                    {label} ({filteredCount})
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>

                                <hr></hr>
                      
                            <DataTable
                                columns={columns}
                                defaultSortFieldId={7}
                                onRowClicked={clickSolicitud}
                                conditionalRowStyles={conditionalRowStyles}
                                data={filteredData}
                                sortFunction={customSort}
                                pagination
                                paginationPerPage={15}
                                onChangePage={handlePageChange}
                                highlightOnHover
                                responsive
                                expandableRows
                                expandableRowsComponent={({ data }) => (
                                    <SubTablaSolicitudes solicitudInternaId={data.id_solicitudinterna} />
                                )}
                            />
                        </>
                    )}
                </div>
            </div>

        {showAgregar && <AgregarSolicitudInterna puertos={dataPuertos} clientes={dataClientes} cerrar={handleCloseAgregar} />}
            {showEditar && <ModificarSolicitudInterna solicitud={selected} puertos={dataPuertos} clientes={dataClientes} cerrar={handleCloseModificar} />}
            {showCPO && <GestionCPO desde={'solicitudesinternas'} solicitud={selectedCPO} ffw={dataFFW} carriers={dataCarrier} puertos={dataPuertos} cerrar={handleCloseCPO} />}
        </div>
    );
};

export default SolicitudesBookingInternas;
